import PropTypes from 'prop-types'

import s from './Bio.module.css'

function Bio({ bio = '' }) {
  return (
    <div className={s.wrapper}>
      <div className={s.container} dangerouslySetInnerHTML={{ __html: bio }} />
    </div>
  )
}

Bio.propTypes = {
  bio: PropTypes.string,
}

export default Bio
